// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentLoader_root__TFsrQ"};